export default "__VITE_ASSET__xh7lbEOt__"